


import { styled } from '@mui/material/styles';

const Label = styled('label')({});

export default Label;